<template>
  <div :class="[`py-5 ${bg}`,gradient ? 'gradient' : '', bg === 'transparent' ? 'primary--text': 'white--text']">
    <h2 class="text-h3 text-center">
      {{ title }}
    </h2>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8" xl="7">
        <v-sheet :class="[`transparent pa-6 text-h5`, bg === 'transparent' ? 'primary--text': 'white--text']">
          <slot />
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'OverviewSection',
  props: {
    title: {
      type: String,
      default: null,
    },
    gradient: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: 'transparent',
    },
  },
  // data: () => ({}),
  // methods: {
  //   aMethod() {},
  // },
}
</script>

<style>
.gradient {
  background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.15));
}
</style>
